import { useEffect, useState } from "react";
import styles from "./pinatareport.module.css";
import { Button, Checkbox, Chip, Dialog, DialogContent, DialogTitle, FormControl, InputLabel, ListItemText, MenuItem, Box, Select, TextField, Typography } from "@mui/material";
import { ArrowLeft, ArrowRight, Download, Filter, Home, Search, X } from "react-feather";
import Helmet from "react-helmet";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { TableLoader } from "../../../components/LoaderC";
import Footer from "../../../components/Footer";
import Loader from "../../../components/Loader";
import axios from "axios";
import { Link } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { forwardRef } from "react";
import NumberFormat from "react-number-format";
import ReportList from "./components/ReportList";
import { toast } from "react-smart-toaster";
import dayjs from "dayjs";
import { useHistory } from "react-router-dom";

const Initials = ({ fullName }) => {
    const parts = fullName.trim().split(" ");
    if (parts.length >= 2) {
        return (
            parts[0].charAt(0).toUpperCase() +
            parts[parts.length - 1].charAt(0).toUpperCase()
        );
    }
    return parts[0].substring(0, 2).toUpperCase();
}

const schema = yup.object().shape({
    min: yup.string().required("This field is Required"),
    max: yup.string().required("This field is Required"),
});

const MoneyField = forwardRef((props, ref) => {
    return (<NumberFormat customInput={TextField} prefix="" displayType="input" type="text" thousandSeparator={true} allowNegative={false} decimalScale={0} {...props} />);
});

const PinataReport = () => {
    const redirect = useHistory();
    const { getAccessTokenSilently } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [filterOpen, setFilterOpen] = useState(false);
    const [allRentrolls, setAllRentrolls] = useState([]);
    const [rentrollList, setRentrollList] = useState([]);
    const [filterData, setFilterData] = useState({ searchKey: "", property: "", rent: "", status: "", date: null });
    const [propertyList, setPropertyList] = useState([]);
    const [addCustomRent, setAddCustomRent] = useState(false);
    const [rentFilterOpen, setRentFilterOpen] = useState(false);
    const [rentFilterText, setRentFilterText] = useState('');
    const [openExportModal, setOpenExportModal] = useState(false);
    const [selectPropertyIds, setSelectPropertyIds] = useState([]);

    const { handleSubmit, control } = useForm({
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        async function getRentrolls() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/report/pinata", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContentLoading(false);
                setAllRentrolls(response.data.data);
            }).catch((error) => {
                setContentLoading(false);
            });
        }
        getRentrolls();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        let filterredDataTemp = allRentrolls;

        if (filterData?.searchKey !== "") {
            let inputVal = filterData?.searchKey;
            inputVal = inputVal.toLowerCase();
            filterredDataTemp = filterredDataTemp.filter((item) => item?.tenant_data?.name?.toLowerCase().includes(inputVal) || item?.tenant_data?.email?.toLowerCase().includes(inputVal) || item?.property_data?.name?.toLowerCase().includes(inputVal) || item?.apt_name?.toLowerCase().includes(inputVal) || item?.rent?.toString().includes(inputVal) || item?.available_balance?.toString().includes(inputVal));
        }

        if (filterData?.property !== "" && filterData?.property !== "all") {
            filterredDataTemp = filterredDataTemp.filter((i) => i.property_id === filterData.property);
        }

        if (filterData?.status !== "" && filterData?.status !== "all") {
            if (filterData?.status === "rented") {
                filterredDataTemp = filterredDataTemp.filter((i) => i.current_status === 2);
            }
            if (filterData?.status === "available") {
                filterredDataTemp = filterredDataTemp.filter((i) => i.current_status === 1);
            }
        }

        if (filterData?.rent !== "" && filterData?.rent !== "all" && filterData?.rent !== "custom") {
            let rentArr = filterData?.rent.split(",");
            let minRent = parseFloat(rentArr[0]);
            let maxRent = parseFloat(rentArr[1]);

            if (maxRent === 0) {
                filterredDataTemp = filterredDataTemp.filter((i) => i.rent >= minRent);
            } else {
                filterredDataTemp = filterredDataTemp.filter((i) => i.rent >= minRent && i.rent < maxRent);
            }
        }

        setRentrollList(filterredDataTemp);
    }, [allRentrolls, filterData]);

    useEffect(() => {
        async function getProperties() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/property-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setPropertyList(response.data.data);
            }).catch((error) => { });
        }
        getProperties();
    }, [getAccessTokenSilently]);

    const onSubmitRentFilter = (data) => {
        setAddCustomRent(false);
        setRentFilterOpen(false);

        setRentFilterText('$' + data.min + ' - $' + data.max);

        setFilterData(prev => {
            return { ...prev, rent: parseInt(data.min.toString().replace(/,/g, ""), 10) + ',' + parseInt(data.max.toString().replace(/,/g, ""), 10) };
        });
    }

    const exportTenants = async () => {
        try {
            if (selectPropertyIds.length === 0) {
                toast.error('Please select property.');
                return false;
            }
            setLoading(true);
            setOpenExportModal(false);

            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            const response = await axios.get(process.env.REACT_APP_USER_API_URL + "v1/report/pinata-report-export",
                {
                    params: { property_ids: selectPropertyIds },
                    responseType: "blob", // 🔥 VERY IMPORTANT
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            setLoading(false);

            const url = window.URL.createObjectURL(
                new Blob([response.data])
            );

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "PinataReport.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url)

        } catch (error) {
            setLoading(false);
            console.error("Export failed", error);
        }
    }

    return (<>
        <Helmet title="Pinata Reports" />
        {loading && <Loader />}
        <div className={`${styles.pageTitleWrap}`}>
            <Typography display="inline" className={`${styles.pageTitle}`}>Pinata Report</Typography>
            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Report</li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>Pinata Report</li>
                </ol>
            </nav>
        </div>

        <div className={`${styles.BodyCon}`}>
            <div className={`${styles.mainCardDiv}`}>
                <div className={`${styles.mainCard}`}>
                    <div className="control-pane">
                        {contentLoading && (<div className="Loader TableLoader"><TableLoader /></div>)}

                        <div className={`${styles.Row}`}>

                            {!contentLoading && <>
                                <div className={`${styles.SearchFilterSec}`}>
                                    <div className={`${styles.SearchCon}`}>
                                        <div className={`${styles.SearchConSec}`}>
                                            <Search />
                                            <input type="text" placeholder="Search" value={filterData?.searchKey} onChange={(e) => { setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; }); }} />
                                        </div>
                                    </div>

                                    <div className={`${styles.FilterSec}`}>
                                        <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                                            <p className={`${styles.FilterTitle}`}>
                                                Filters
                                                <span onClick={(e) => setFilterOpen(false)}>
                                                    <ArrowRight />
                                                </span>
                                            </p>
                                            <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Property</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        label="Property"
                                                        value={filterData?.property}
                                                        onChange={(e) => {
                                                            setFilterData((prev) => { return { ...prev, property: e.target.value }; });
                                                        }}
                                                    >
                                                        <MenuItem value={'all'}>Any</MenuItem>
                                                        {propertyList?.map((i) => {
                                                            return (<MenuItem value={i.value}>{i.label}</MenuItem>);
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Rent Amount Range</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        label="Rent Amount Range"
                                                        value={filterData?.rent}
                                                        onChange={(e) => {
                                                            setFilterData((prev) => { return { ...prev, rent: e.target.value }; });
                                                            setRentFilterOpen(true);

                                                            if (e.target.value === 'custom') {
                                                                setAddCustomRent(true);
                                                            } else {
                                                                setAddCustomRent(false);
                                                            }
                                                        }}
                                                        open={rentFilterOpen}
                                                        onClose={(e) => { setRentFilterOpen(false); }}
                                                        onOpen={(e) => setRentFilterOpen(true)}
                                                        renderValue={(selected) => {
                                                            if (!selected) return "";
                                                            if (selected === "all")
                                                                return "All Rent";
                                                            else if (selected === "0,300")
                                                                return "< $300";
                                                            else if (selected === "300,600")
                                                                return "$300 - $600";
                                                            else if (selected === "600,900")
                                                                return "$600 - $900";
                                                            else if (selected === "900,1200")
                                                                return "$900 - $1,200";
                                                            else if (selected === "1200,0")
                                                                return "> $1,200";
                                                            else if (selected === "custom")
                                                                return "Custom";
                                                            else if (rentFilterText !== '')
                                                                return rentFilterText;
                                                            else
                                                                return "";

                                                        }}
                                                    >
                                                        <MenuItem value="all">All Rent</MenuItem>
                                                        <MenuItem value="0,300">&lt; $300</MenuItem>
                                                        <MenuItem value="300,600">$300 - $600</MenuItem>
                                                        <MenuItem value="600,900">$600 - $900</MenuItem>
                                                        <MenuItem value="900,1200">$900 - $1,200</MenuItem>
                                                        <MenuItem value="1200,0">&gt; $1,200</MenuItem>
                                                        <MenuItem value="custom" className={`${styles.customcredit}`} onClick={(e) => { setAddCustomRent(true); }}>Custom Range Filter</MenuItem>
                                                        {addCustomRent && (<div className={`${styles.CustomFilterSec}`}>
                                                            <form onSubmit={handleSubmit(onSubmitRentFilter)}>
                                                                <div className={`${styles.CustomFilterSecRow}`}>
                                                                    <div className={`${styles.CustomFiletrField} FormGroup`}>
                                                                        <Controller
                                                                            name={`min`}
                                                                            control={control}
                                                                            render={(field) => (<MoneyField
                                                                                {...field}
                                                                                id="outlined-basic"
                                                                                label="Min Rent"
                                                                                variant="outlined"
                                                                                onClick={(e) => e.stopPropagation()}
                                                                                onKeyDown={(e) => e.stopPropagation()}
                                                                                onChange={(e) => {
                                                                                    e.stopPropagation();
                                                                                    field.onChange(e);
                                                                                }}
                                                                            />)}
                                                                        />
                                                                    </div>
                                                                    <div className={`${styles.CustomFiletrField} FormGroup`}>
                                                                        <Controller
                                                                            name={`max`}
                                                                            control={control}
                                                                            render={(field) => (<MoneyField
                                                                                {...field}
                                                                                id="outlined-basic"
                                                                                label="Max Rent"
                                                                                variant="outlined"
                                                                                onClick={(e) => e.stopPropagation()}
                                                                                onKeyDown={(e) => e.stopPropagation()}
                                                                                onChange={(e) => {
                                                                                    e.stopPropagation();
                                                                                    field.onChange(e);
                                                                                }}
                                                                            />)}
                                                                        />
                                                                    </div>
                                                                    <div className={`${styles.CustomFiletrBUsec}`}>
                                                                        <Button onClick={(e) => { setAddCustomRent(false); setFilterData((prev) => { return { ...prev, rent: "" }; }); setRentFilterOpen(false); }} className={`${styles.CancelPopupBU}`}>Cancel</Button>
                                                                        <Button className={`${styles.SubmitPopupBU}`} type="submit">Apply</Button>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div>)}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>
                                        <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                                            <Filter />
                                        </Link>
                                        <Link className={`${styles.AddNoteBu}`} onClick={(e) => { setOpenExportModal(true); setSelectPropertyIds([]); }}>
                                            <Download /> <span>Export Report</span>
                                        </Link>
                                    </div>
                                </div>

                                <div className={`${styles.IncomeListingBody}`}>
                                    <div className={`${styles.IncomeListSec}`}>
                                        <ReportList rentrollList={rentrollList} />
                                    </div>
                                </div>

                                <div className={`${styles.ListMobileView}`}>
                                    {rentrollList?.map((item, index) => {
                                        return <div key={index} className={`${styles.MaintenanceReqCard}`}>
                                            <div className={`${styles.FirstSec} ${styles.ProfileImg}`}>

                                                <div className={`${styles.ProNameIMG}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (item?.id) { redirect.push("/people/tenants/details/" + item.id); } }}>
                                                    {item?.tenant_image !== "" ? (<img src={item?.tenant_image} alt="" />) : (<p><Initials fullName={item?.tenant_data?.name} /></p>)}
                                                </div>
                                                <div>
                                                    <p className={`${styles.Name} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); if (item?.id) { redirect.push("/people/tenants/details/" + item.id); } }}>
                                                        {item?.tenant_data?.name}
                                                    </p>
                                                    <p className={`${styles.Name} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/properties/details/" + item?.property_id); }}>{item?.property_data?.name} - {item?.apt_name}</p>
                                                </div>
                                            </div>
                                            <div className={`${styles.SecondSec}`}>
                                                <div className={`${styles.Flex}`}>
                                                    <p className={`${styles.Name}`}>Email: <span>{item?.tenant_data?.email}</span></p>
                                                    <p className={`${styles.Name}`}>Rent Due Day: <span>1st</span></p>
                                                </div>
                                                <div className={`${styles.Flex}`}>
                                                    <p className={`${styles.Name}`}>
                                                        Rent:
                                                        <span>{item?.rent?.toLocaleString('en-US', {
                                                            style: 'currency',
                                                            currency: 'USD',
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })}</span>
                                                    </p>
                                                    <p className={`${styles.Name}`}>
                                                        Outstanding:
                                                        <span>{item?.available_balance?.toLocaleString('en-US', {
                                                            style: 'currency',
                                                            currency: 'USD',
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })}</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className={`${styles.ThirdSec}`}>
                                                <p className={`${styles.Flex}`}>
                                                    <p className={`${styles.Name} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/leases/details/" + item?.id); }}>{dayjs(item?.lease_start_date).format('MM/DD/YYYY') + ' - ' + dayjs(item?.lease_end_date).format('MM/DD/YYYY')}</p>
                                                    <p className={`${styles.Name}`}>
                                                        DOB: <span>{item?.tenant_data?.birth_date ? dayjs(item?.tenant_data?.birth_date).format('MM-DD-YYYY') : '-'}</span>
                                                    </p>
                                                </p>
                                            </div>
                                        </div>
                                    })}
                                </div>


                            </>}

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Dialog
            open={openExportModal}
            fullWidth
            maxWidth="xs"
            onClose={(e) => setOpenExportModal(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp CustomWidthPopUs MobileForm"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => setOpenExportModal(false)}><ArrowLeft /></button>
                <span>Export Pinata Report</span>
                <button onClick={(e) => setOpenExportModal(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <div className={`${styles.AddprospectFirstStepForm}`}>
                    <p className={`${styles.AddprospectFirstStepFormTitle}`}> Please select a property before exporting the Pinata Report.</p>
                    <p className={`${styles.AddprospectFirstStepFormTitleTwo}`}>The full report will be generated using your selected property.The file will include tenant, lease, rent, and outstanding balance details.</p>
                    <div className={`${styles.HalfStepFormRow}`}>
                        <div className={`${styles.HalfStepFormFullSec} FormGroup`}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Select Property*</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Select property*"
                                    multiple
                                    value={selectPropertyIds}
                                    onChange={(e) => {
                                        if (e.target.value?.indexOf('All') > -1) {
                                            if (selectPropertyIds.length === propertyList.length) {
                                                setSelectPropertyIds([]);
                                            } else {
                                                let allP = propertyList?.map(i => i?.value);
                                                setSelectPropertyIds(allP);
                                            }
                                        } else {
                                            setSelectPropertyIds(e.target.value);
                                        }
                                    }}
                                    renderValue={(selected) => {
                                        return <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                            {propertyList?.map(item => {
                                                return (selected?.indexOf(item?.value) > -1) ? (<Chip key={item?.value} label={item?.label} />) : null;
                                            })}
                                        </Box>
                                    }}
                                >
                                    <MenuItem value="All">
                                        <Checkbox
                                            checked={propertyList.length > 0 && selectPropertyIds.length === propertyList.length}
                                            indeterminate={selectPropertyIds.length > 0 && selectPropertyIds.length < propertyList.length}
                                        />
                                        <ListItemText primary="All Properties" />
                                    </MenuItem>
                                    {propertyList?.map((i) => {
                                        return (<MenuItem key={i?.value} value={i?.value}>
                                            <Checkbox checked={selectPropertyIds.indexOf(i?.value) > -1} />
                                            <ListItemText primary={i?.label} />
                                        </MenuItem>);
                                    })}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className={`${styles.ButtonAction}`}>
                        <Button onClick={(e) => setOpenExportModal(false)} className="CancelPopupBU">Cancel</Button>
                        <Button className="SubmitPopupBU" onClick={(e) => exportTenants()}>Export</Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>

        <Footer />
    </>);
}

export default withAuthenticationRequired(PinataReport, {
    onRedirecting: () => <Loader />,
});